export class SearchFilter {
  fromDate: Date;
  toDate: Date;
  reportName: string;
  reportHighlights: string;
  reportNumber: string;
  keyword: string;
  categoryIds: number[] = new Array<number>();
  postIds: number[] = new Array<number>();
  postNames: string[] = new Array<string>();
  countryIds: number[] = new Array<number>();
  correctedReport: boolean;
  displayInternal: boolean;
}

export class SearchResult {
  reportId: string;
  reportName?: string;
  reportHighlights: string;
  publishDate?: Date;
  reportDate: Date;
  reportYear: number;
  postName: string;
  isPublic: boolean;
  isRequired: boolean;
  isLegacy: boolean;
  fileName: string;
  //preferredName: string;
  countryName: string;
  reportCategory: string;
  reportNumber: string;
  reportStateId: number;
  reportState: string;
  currentVersion: number;
  approvedSentToWashingtonDate: Date;
}

export class QuickLinkResult{
  reportId :string;
  reportName :string;
  fileName :string;
  fileExtension:string;
  countryName:string;
  postName:string;
  publishedOn:Date;
  isRequired:boolean;
  isPublic:boolean;
}

export class PublishedReportHistory{
  id: number;
  publishReportId: string;
  publishedOn: Date;
  //reportContent: Uint8Array[];
  fileName: string;
  fileExtension: string;
  reportVersion: number;
}

